import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date | undefined | null): string {
  if (!date) return '未知';
  
  const d = typeof date === 'string' ? new Date(date) : date;
  
  // Check if date is invalid
  if (isNaN(d.getTime())) return '未知';
  
  const now = new Date();
  const diff = now.getTime() - d.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 7) {
    return d.toLocaleDateString('zh-TW', { year: 'numeric', month: 'short', day: 'numeric' });
  } else if (days > 0) {
    return `${days}天前`;
  } else if (hours > 0) {
    return `${hours}小時前`;
  } else if (minutes > 0) {
    return `${minutes}分鐘前`;
  } else {
    return '剛剛';
  }
}

export function truncate(str: string, maxLength: number): string {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + '...';
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return (...args: Parameters<T>) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

export function getStatusColor(status: string): string {
  const colors = {
    running: 'text-status-running',
    paused: 'text-status-paused',
    draft: 'text-status-draft',
    stopped: 'text-status-stopped',
  };
  return colors[status as keyof typeof colors] || 'text-status-draft';
}

export function getStatusBgColor(status: string): string {
  const colors = {
    running: 'bg-status-running/10',
    paused: 'bg-status-paused/10',
    draft: 'bg-status-draft/10',
    stopped: 'bg-status-stopped/10',
  };
  return colors[status as keyof typeof colors] || 'bg-status-draft/10';
}

export function parseAgentId(agentId: string): { ownerId: string; agentName: string } | null {
  const parts = agentId.split(':');
  if (parts.length !== 2) return null;
  return { ownerId: parts[0], agentName: parts[1] };
}
